import { useNavigate } from "react-router-dom";
import { MyItemsView } from "@/features/physician/review-queue/components/MyItemsView";

export function PhysicianMyItemsPage() {
  const navigate = useNavigate();
  return <MyItemsView onOpenItem={(id) => navigate(`/physician/my-items/${encodeURIComponent(id)}`)} />;
}
